export default "42de98a139d40c39.png"